import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { ProductsOverviewTable } from '../../products/components/ProductsOverviewTable';
import { Loader } from '../../../components/Loader';
import { fetchInvoice } from '../../Invoices/actions';
import { selectInvoice, selectInvoiceById } from '../../Invoices/selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_INVOICE } from '../../Invoices/constants';
import { ProductSubjectDetails } from '../../products/components/ProductSubjectDetails';
import { HBox } from '../../../components/Box';

const Container = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  background-color: white;

  .cell:first-child {
    text-transform: capitalize;
  }
  .wide {
    width: 100%;
    max-width: 800px;
  }
  .info-card {
    border: none;
  }

  .status-label {
    width: fit-content;
  }

  .cell-value {
    white-space: nowrap;
  }
`;

const STATE = {
  isOpen: false,
  incomingInvoice: null,
  userBuyer: null,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleOutgoingProductInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetch();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get invoice() {
    return this.props.invoice;
  }

  get companyId() {
    return this.props.invoice?.companyForAccounting?.id;
  }

  get currentSubject() {
    return this.invoice?.invoiceSubjects?.find(sub => sub?.id == this.state.currentSubjectId) ?? {};
  }

  get products() {
    return this.invoice?.invoiceSubjects
      ?.filter(sub => sub.type == 'product')
      .map(p => {
        let originalPrice = '';
        let quantity = p?.product?.isOneTime == 1 ? p?.one_time : p?.one_time && p?.one_time > 1 ? p?.one_time : p?.counter;
        if (!p?.product?.id && p?.one_time) {
          quantity = p?.one_time;
        }
        if (+p?.product_price_excl_vat_per_item) {
          originalPrice = +p?.product_price_excl_vat_per_item;
        }
        const parsedProduct = {
          id: p?.id,
          name: p?.description ?? p?.product?.name,
          description: p?.product?.description ?? p?.description,
          purchasePriceExclVat: originalPrice,
          salesPriceExclVat: originalPrice,
          totalPriceExclVat: p?.product_price_excl_vat,
          quantity,
        };
        return parsedProduct;
      });
  }

  addProduct(option, currentSubjectId = null) {
    this.setState({
      showAddProductModal: true,
      edit: option == 'edit' ? true : false,
      currentSubjectId: option == 'edit' ? currentSubjectId : null,
    });
  }

  renderAddProductModal() {
    return (
      <ProductSubjectDetails
        invoice={this.invoice}
        vehicle={this.props.vehicle}
        vehicleId={this.props.vehicleId}
        editMode={this.state.edit || false}
        currentSubject={this.state.currentSubjectId ? this.currentSubject : null}
        onClose={() => {
          this.setState({ showAddProductModal: false, edit: false, currentSubjectId: null });
        }}
        companyId={this.companyId}
      />
    );
  }

  render() {
    if (!this.props.invoiceId || this.props.work) return <Loader small />;

    return (
      <Container>
        {this.state.showAddProductModal && this.renderAddProductModal()}
        <Card className="vehicle-info-card info-card info wide" style={{ width: '100%' }}>
          <HBox vCenter style={{ height: '250px' }}>
            <ProductsOverviewTable
              productInvoicePage
              invoiceId={this.invoice?.id}
              addProduct={this.addProduct.bind(this)}
              vehicleId={this.props.vehicleId}
              productSubjects={this.products}
              direction={this.invoice?.direction}
              companyId={this.companyId}
            />
          </HBox>
        </Card>
      </Container>
    );
  }
}

VehicleOutgoingProductInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_INVOICE),
    invoice: selectInvoiceById(ownProps.invoiceId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchInvoice(ownProps.invoiceId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleOutgoingProductInvoiceCard = compose(withConnect, withRouter)(VehicleOutgoingProductInvoiceCardComp);
